import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { TCategoriesTree } from '@features/categories/typescript';
import { IBreadcrumbStep } from '@typescript/index';
import { IMarketingCategoryResponse } from '@features/productPreview/typescript';
import Breadcrumbs from '@components/Breadcrumbs/Breadcrumbs';
import layoutUiState from '@features/layout/mobX/LayoutUiState';
import { searchCategoryTree } from '@utils/categoriesData';
import { createBreacrumbs } from '@utils/breadcrumbs';
import { ICategory } from '@features/categories/typescript';
type PropsType = {
  marketingCategoriesResponse: IMarketingCategoryResponse;
  categoriesTree: TCategoriesTree;
};
const ProductBreadcrumbs = ({
  marketingCategoriesResponse,
  categoriesTree
}: PropsType) => {
  const {
    lastVisitedCategoryId,
    setLastVisitedCategoryId
  } = layoutUiState;
  const {
    t
  } = useTranslation('common');
  const {
    marketingCategories: productMarketingCategories,
    productName
  } = marketingCategoriesResponse;
  const breadcrumbsCategoryId = useMemo(() => {
    if (lastVisitedCategoryId && searchCategoryTree(Object.values(categoriesTree), lastVisitedCategoryId) && !!productMarketingCategories.find(category => category.id === lastVisitedCategoryId)) return lastVisitedCategoryId;
    const firstAvailableCategoryId = productMarketingCategories.find(category => searchCategoryTree(Object.values(categoriesTree), category.id));
    if (!firstAvailableCategoryId && productMarketingCategories.length > 0) {
      return productMarketingCategories[0].id;
    }
    return firstAvailableCategoryId ? firstAvailableCategoryId.id : null;
  }, [productMarketingCategories, categoriesTree, lastVisitedCategoryId]);
  const breadcrumbSteps = useMemo<IBreadcrumbStep[]>(() => {
    const lastStep: IBreadcrumbStep = {
      name: productName,
      id: -1
    };
    const categories = Object.values(categoriesTree);
    if (breadcrumbsCategoryId && searchCategoryTree(categories as ICategory[], breadcrumbsCategoryId)) {
      setLastVisitedCategoryId(null);
      const buildSteps = createBreacrumbs(t('home'), categoriesTree, breadcrumbsCategoryId, undefined, undefined, [lastStep]);
      return buildSteps;
    }
    if (lastVisitedCategoryId && searchCategoryTree(categories as ICategory[], lastVisitedCategoryId)) {
      const buildSteps = createBreacrumbs(t('home'), categoriesTree, lastVisitedCategoryId, undefined, undefined, [lastStep]);
      return buildSteps;
    }
    return [{
      name: t('home'),
      href: {
        pathname: '/',
        query: {}
      },
      id: 0
    }, lastStep];
  }, [productMarketingCategories, categoriesTree, breadcrumbsCategoryId, lastVisitedCategoryId, t, productName]);
  return breadcrumbSteps.length ? <Breadcrumbs steps={breadcrumbSteps} /> : null;
};
export default observer(ProductBreadcrumbs);